import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
// import { UatFlagComponent } from './uat-flag/uat-flag.component';

@Component({
  selector: 'app-root',
  // standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  
  // imports: [UatFlagComponent, MatIconModule],
})

export class AppComponent {

  title = 'leaflet-frontend-angular';

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.iconRegistry.addSvgIcon(
      'menu-open', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/menu-arrow.svg')
    );
  }
}
